exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onlineVehicles {\n  padding: 20px 5px;\n  background: #182d35;\n  color: #fff;\n  font-size: 14px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n  -ms-flex-align: center;\n      align-items: center;\n  border: 5px solid #3e5764;\n  margin: 0px 10px 10px;\n  box-shadow: 0px 3px 5px #212c32;\n  border-radius: 7px;\n  direction: initial;\n  cursor: pointer; }\n  .onlineVehicles .title {\n    color: #14dc36; }\n  .onlineVehicles .count {\n    font-size: 16px;\n    font-weight: bolder;\n    color: #fff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/OnlineVehicles/OnlineVehicles.component.scss
// module id = ../../../../../app/shared/components/OnlineVehicles/OnlineVehicles.component.scss
// module chunks = main